import { render } from "./LinksAndNews.vue?vue&type=template&id=9a1b7880&scoped=true"
import script from "./LinksAndNews.vue?vue&type=script&lang=js"
export * from "./LinksAndNews.vue?vue&type=script&lang=js"

import "./LinksAndNews.vue?vue&type=style&index=0&id=9a1b7880&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1b7880"]])

export default __exports__